export const PreferencesCacheKey = ['accountPreferences'];